import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { DefaultRoutes, Route } from './routes';
import { SideNavToggle } from './sidebar/sidebar.component';

@Component({
    selector: 'app-core',
    templateUrl: './core.component.html',
    styleUrls: ['./core.component.scss'],
    standalone: false
})
export class CoreComponent {
    routes: Route[];
    title = 'Bienvenid@';
    isSideNavCollapsed = false;
    screenWidth = 0;
    isMobile = false;
    userName = '';

    constructor(private router: Router, private location: Location, private authService: AuthService) {
        this.routes = this.authService.getUserRoutes();

        this.authService.currentUser$.subscribe((user) => {
            this.userName = user?.nombre ?? '';
            this.setHeaderTitle();
        });
    }

    ngOnInit() {
        this.setHeaderTitle();
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((_) => {
            this.setHeaderTitle();
        });
    }

    /**
     * Sets the title of the page based on the current path.
     * @returns None
     */
    setHeaderTitle(): void {
        const pathName = this.getPathName(this.routes, this.location.path());
        this.title = pathName ? pathName : this.title;
    }

    /**
     * Capitalizes the first letter of a given text and converts the rest to lowercase.
     * @param {string} text - The text to capitalize.
     * @returns {string} The capitalized text.
     */
    private capitalizeFirstLetter(text: string): string {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    /**
     * Gets the path name of the page based on the routes, there are specific routes for that reason we are using the DefaultRoutes enum
     * @param {Route[]} routes - Available routes
     * @param {string} path - Path to compare
     * @returns {string}
     */
    getPathName(routes: Route[], path: string): string | undefined {
        let pathName = routes.find((route) => route.path === path)?.name;
        if (path.includes(DefaultRoutes.home)) {
            pathName = `Bienvenid@, ${this.capitalizeFirstLetter(this.userName)} `;
            return pathName;
        }
        if (!pathName) {
            const mainPath = DefaultRoutes.dataVisualization;
            if (path.includes(mainPath)) {
                const subroute = routes.find((route) => route.path === mainPath)?.subroutes?.find((subroute) => path.includes(mainPath + subroute.path));
                pathName = subroute?.name;
            } else {
                pathName = routes.find((route) => path.includes(route.path))?.name;
            }
        }
        return pathName;
    }

    /**
     * A function that is called when the side nav is toggled.
     * @param {any} data - the data passed in from the event
     * @returns None
     */
    onToggleSideNav(data: SideNavToggle): void {
        this.screenWidth = data.screenWidth;
        this.isMobile = data.isMobile;
        this.isSideNavCollapsed = data.isCollapsed;
    }

    /**
     * Returns the class name for the body element.
     * @returns {string} The class name for the body element.
     */
    getBodyClass(): string {
        let styleClass = '';
        if (this.isSideNavCollapsed) {
            styleClass = 'collapsed';
        } else {
            styleClass = 'not-collapsed';
        }
        return styleClass;
    }
}
